import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import SepiaImage from '../../components/SepiaImage';

const SepiaPage: React.FC = () => (
  <ToolLayout
    title="Sepia Filter - Vintage Photo Effect | AllTools"
    description="Apply sepia tone to photos. Classic, warm, cool, and antique styles with vignette and grain effects. Free tool."
    canonicalPath="/sepia-filter"
  >
    <SepiaImage />
  </ToolLayout>
);

export default SepiaPage;
